import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export function businessList(data) {
    return axios.post(`${base.url}/auth/business/list`,JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function editbusinessList(data) {
    return axios.post(`${base.url}/auth/business/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function addbusinessList(data) {
    return axios.post(`${base.url}/auth/business/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function resetAppkey(data) {
    return axios.post(`${base.url}/auth/business/reset`, qs.stringify(data));
}
export function delbusinessList(id) {
    return axios.get(`${base.url}/auth/business/del?id=${id}`);
}
export function businessStatus(data) {
    return axios.get(`${base.url}/auth/business/status?id=${data.id}&status=${data.status}`);
}

